// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Modal {\n  max-width: 360px;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.Modal-content {\n  background-color: var(--color-white);\n  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);\n  border-radius: 16px;\n}", ""]);
// Exports
module.exports = exports;
